import { 
  OutlinedInput, 
  Select, 
  Typography, 
  MenuItem,
  FormControl,
  FormHelperText 
} from "@mui/material";
import { Stack, useTheme } from "@mui/system";
import React from "react";
import Loader from "../Loading/AutobiaLoader";

const AutobiaSelect = ({
  value,
  options = [],
  onChange,
  title,
  placeholder = "Select an option",
  height = "40px",
  isLoading = false,
  disabled = false,
  error = false,
  helperText,
  fullWidth = true,
  color = "primary",
}) => {
  const theme = useTheme();

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  return (
    <Stack sx={{ width: fullWidth ? "100%" : "auto" }}>
      {title && (
        <Typography
          variant="body2"
          color={theme.palette.gray.g600}
          fontWeight={600}
          sx={{ mb: 0.5 }}
        >
          {title}
        </Typography>
      )}
      
      {isLoading ? (
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            height: height,
            border: "1px solid",
            borderColor: theme.palette.gray.g200,
            borderRadius: "10px",
            backgroundColor: "white",
          }}
        >
          <Loader />
        </Stack>
      ) : (
        <FormControl
          fullWidth={fullWidth}
          error={error}
          variant="outlined"
        >
          <Select
            displayEmpty
            value={value}
            onChange={onChange}
            disabled={disabled}
            color={color}
            input={
              <OutlinedInput
                color={color}
                sx={{
                  borderRadius: "10px",
                  height: height,
                  backgroundColor: "white",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: color === "secondary"
                      ? theme.palette.secondary.main
                      : theme.palette.primary.main,
                  },
                  "&.Mui-disabled": {
                    backgroundColor: theme.palette.gray.g50,
                  },
                }}
                inputProps={{
                  sx: {
                    padding: "9px 14px",
                    backgroundColor: "transparent",
                  },
                }}
              />
            }
            MenuProps={MenuProps}
            sx={{
              overflow: "hidden",
            }}
          >
            <MenuItem value="" disabled>
              <Typography color="gray.g400">
                {placeholder}
              </Typography>
            </MenuItem>
            {options.map((option) => (
              <MenuItem 
                key={option.value} 
                value={option.value}
                sx={{
                  '&:hover': {
                    backgroundColor: theme.palette.primary.light,
                  },
                  '&.Mui-selected': {
                    backgroundColor: theme.palette.primary.main,
                    color: 'white',
                    '&:hover': {
                      backgroundColor: theme.palette.primary.dark,
                    },
                  },
                }}
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {helperText && (
            <FormHelperText sx={{ mt: 0.5 }}>
              {helperText}
            </FormHelperText>
          )}
        </FormControl>
      )}
    </Stack>
  );
};

export default AutobiaSelect;